import { useState, useEffect } from "react";
import { fetchJsonNoParse, basicFetch } from "../../lib/Fetching";

function useAsyncResponse({ asyncResponse, onComplete, onError }) {
  const [json, setJson] = useState(null);
  const [iteration, setIteration] = useState(0);

  const { json_url } = asyncResponse;

  const fetchResponse = () => {
    if (json) setJson(null);
    return fetchJsonNoParse(json_url, {})
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        if (response.status === 404) {
          setIteration(iteration + 1);
        }
        return Promise.reject({ status: response.status });
      })
      .then((json) => {
        onComplete && onComplete();
        if (json.errors) {
          onError && onError(json.errors);
          alert(json.errors);
          return;
        }
        setJson(json);
      })
      .catch((e) => {
        if (e.status !== 404) {
          alert("There was an error fetching the data. Please contact i2 support.");
          onError && onError(json.errors);
          onComplete && onComplete();
        }
      });
  };

  // start iterations
  useEffect(() => setIteration(1), [json_url]);

  // Fetch response data at regular intervals
  useEffect(
    () => {
      if (!json_url || iteration < 1) return;
      const timeout = iteration < 10 ? 500 : 1000;
      const timer = setTimeout(() => fetchResponse(), timeout);
      return () => clearTimeout(timer);
    },
    [json_url, iteration]
  );

  return { json };
}

function useAsyncResponseHtml({ asyncResponse }) {
  const [html, setHtml] = useState(null);
  const [iteration, setIteration] = useState(0);

  const { html_url } = asyncResponse;

  const fetchResponse = () => {
    if (html) setJson(null);
    return basicFetch(html_url, {})
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        if (response.status === 404) {
          setIteration(iteration + 1);
          return;
        }
        return Promise.reject({ status: response.status });
      })
      .then((text) => setHtml(text))
      .catch((e) => {
        alert("There was an error fetching the data. Please contact i2 support.");
      });
  };

  // start iterations
  useEffect(() => setIteration(1), [html_url]);

  // Fetch response data at regular intervals
  useEffect(
    () => {
      if (!html_url || iteration < 1) return;
      const timeout = iteration < 10 ? 500 : 1000;
      const timer = setTimeout(() => fetchResponse(), timeout);
      return () => clearTimeout(timer);
    },
    [html_url, iteration]
  );

  return { html };
}

export { useAsyncResponse, useAsyncResponseHtml };
